import BarGraph from "./BarGraph";
// import { payoutAmountData } from "../PayoutManagement/helper/payoutdatasample";



 const ChartDashboard = (props) =>{

  const {payoutAmountData, disbursementCountData} = props;

    

    return (
     
  payoutAmountData.length > 0 && disbursementCountData.length > 0 ? (
    <div className="bargraphContainer">
      <div className="bargraph1">
        <BarGraph data={payoutAmountData} title={"Payout Amount"} />
      </div>
      <div className="bargraph2">
        <BarGraph data={disbursementCountData} title={"Disbursement Count"} />
      </div>
    </div>
  ) : null
);

 }

 export default ChartDashboard;